import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import StudentRegistration from "./Components/StudentPortal/StudentRegistration";
import CoursePlayer from "./Components/StudentPortal/CoursePlayer";
import LeaderBoard from "./Components/StudentPortal/LeaderBoard";
import Quiz from "./Components/StudentPortal/Quiz";
import AdminLogin from "./Components/Dashboard/AdminLogin";
import useAuthCheck from "./hooks/useAuthCheck";
import Dashboard from "./Components/Dashboard/Dashboard";
import Videos from "./Components/Dashboard/Videos";
import Quizess from "./Components/Dashboard/Quizess";
import AssignmentMark from "./Components/Dashboard/AssignmentMark";
import PrivateRoute from "./Components/PrivateRoute";
import AdminPrivateRoute from "./Components/AdminPrivateRoute";
import PublicRoute from "./Components/PublicRoute";
import AdminPublicRoute from "./Components/AdminPublicRoute";
import PageNotFound from "./Components/PageNotFound";
import Assignment from "./Components/Dashboard/Assignment";
import AddVideo from "./Components/Dashboard/AddVideo";

function App() {
  const authChecked = useAuthCheck();
  return !authChecked ? (
    <div>Checking Authentication...</div>
  ) : (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />
        <Route
          path="/studentRegistration"
          element={
            <PublicRoute>
              <StudentRegistration />
            </PublicRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminPublicRoute>
              <AdminLogin />
            </AdminPublicRoute>
          }
        />
        <Route
          path="/courseplayer"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="/courseplayer/:id"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <PrivateRoute>
              <LeaderBoard />
            </PrivateRoute>
          }
        />
        <Route
          path="/quiz/:id"
          element={
            <PrivateRoute>
              <Quiz />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminPrivateRoute>
              <Dashboard />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/assignment"
          element={
            <AdminPrivateRoute>
              <Assignment />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/videos"
          element={
            <AdminPrivateRoute>
              <Videos />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes"
          element={
            <AdminPrivateRoute>
              <Quizess />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/assignmentMark"
          element={
            <AdminPrivateRoute>
              <AssignmentMark />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/addVideo"
          element={
            <AdminPrivateRoute>
              <AddVideo />
            </AdminPrivateRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
